import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TaskDetailsObject } from 'src/app/models/tasks/tasks-details/task-details.model';
import { TaskService } from 'src/app/services/api/tasks/specific-task/task.service';
import { isNull } from 'util';
import { Subscription } from 'rxjs';
import { TaskAssignObject } from 'src/app/models/tasks/task/task-assign-object.model';
import { BreadcrumbsService } from 'src/app/services/utils/breadcrumbs.service';
import { KeycloakService } from 'keycloak-angular';
import { Role } from 'src/app/utils/Role';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { MatDialog } from '@angular/material/dialog';
import { AssignQueueComponent } from './assign-queue/assign-queue.component'; 

@Component({
  selector: 'app-specific-task',
  templateUrl: './specific-task.component.html',
  styleUrls: ['./specific-task.component.css']
})
export class SpecificTaskComponent implements OnInit {

  title = 'Tarea';
  backUrl = '/provision/tasks/search';

  currentTaskAssign: TaskAssignObject;
  taskId: string;
  isBillingTask: boolean;
  orderId: string;
  serviceId: string;

  taskAssignSubscription: Subscription;
  taskSaveAndRelaunchSubscription: Subscription;
  taskRelaunchSubscription: Subscription;
  taskSkipSubscription: Subscription;

  taskDetails: TaskDetailsObject;

  params: any;
  userId: string;

  disableRelease: boolean = true;
  releaseAllowed: boolean = false;

  constructor(private activatedRoute: ActivatedRoute,
    private taskService: TaskService,
    private breadcrumbsService: BreadcrumbsService, 
    private keycloakService: KeycloakService, 
    private utilsService: UtilsService,
    private dialog: MatDialog) {

  }

  ngOnInit() {
    const keycloakTokenParsed = this.keycloakService.getKeycloakInstance().tokenParsed;
    this.userId = keycloakTokenParsed['preferred_username'];
    this.releaseAllowed = this.keycloakService.getUserRoles().includes(Role.ReleaseTask);

    this.isBillingTask = false;
    this.currentTaskAssign = TaskAssignObject.UNKNOWN;

    this.activatedRoute.queryParams.subscribe(params => {
      this.taskId = params.id;
      this.params = params;
      this.breadcrumbsService.sendBreadcrumbs(
        {
          breadcrumbs:
            [
              { title: 'Tareas', url: 'provision/tasks/search' },
              { title: 'Detalle de tarea', url: `provision/tasks/detail`, params: { id: this.params.id } }
            ]
        }
      );
    });

    this.loadTask(this.taskId);

  }
  public isNeedReload(currentTaskAssign: TaskAssignObject, newTaskAssign: TaskAssignObject): boolean {
    return (currentTaskAssign.equals(TaskAssignObject.TAKEN) && newTaskAssign.equals(TaskAssignObject.LEFT))
      || (currentTaskAssign.equals(TaskAssignObject.LEFT) && newTaskAssign.equals(TaskAssignObject.TAKEN))
  }

  private loadTask(taskId: string) {
    this.taskService.getTask(taskId).subscribe(
      (task: TaskDetailsObject) => {
        task.getTaskCharacteristics().inputCharacteristics.sort((x, y) => {
          return y.id > x.id ? -1 : 1;
        });
        task.getTaskCharacteristics().outputCharacteristics.sort((x, y) => {
          return y.id > x.id ? -1 : 1;
        });
        this.taskDetails = task;
        this.currentTaskAssign = this.getAssignOption(task);
        this.disableRelease = !this.utilsService.isAssignToUser(task, this.userId);
      },
      (error) => {
        console.error(error);
      });
  }


  private getAssignOption(task: TaskDetailsObject) {
    let assignedTo = task.getProperties().getTaskProperties().getAssignedTo();
    if (!isNull(assignedTo)) {
      return TaskAssignObject.TAKEN;
    }
    return TaskAssignObject.LEFT;

  }

  public takeTask() {
    this.taskService.assingTask(this.taskId, this.userId).subscribe(
      (data) => {
        this.loadTask(this.taskId);
      }
    );
  }

  public leaveTask() {
    this.taskService.leaveTask(this.taskId).subscribe(
      (data) => {
        this.loadTask(this.taskId);
      }
    );
  }

  public assignQueue() {
    const matDialogRef = this.dialog.open(AssignQueueComponent, {
      data: {
        taskid: this.taskId
      },
      disableClose: true,
      hasBackdrop: true,
      maxHeight: '70%',
      restoreFocus: false,
      autoFocus: false
    });
  }

}
